import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  LiveReload,
} from "@remix-run/react";
import type { LinksFunction } from "@remix-run/node";
import { SpeedInsights } from "@vercel/speed-insights/remix";
import { Analytics } from "@vercel/analytics/remix";
import { Analytics as CustomAnalytics } from "./components/Analytics";
import "./styles/app.css";

export const links: LinksFunction = () => [
  // CSS is imported directly above
];

export default function App() {
  return (
    <html lang="zh-CN">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        
        {/* 基础SEO元数据 */}
        <meta name="description" content="女孩的秘密 - 专业的女性健康管理平台，提供月经周期管理、排卵期预测、安全期计算、预产期计算等功能。科学管理女性健康，守护每一个重要时刻。" />
        <meta name="keywords" content="月经周期,排卵期,安全期,女性健康,预产期计算,月经管理,生理周期,孕期计算,女性生理,健康管理" />
        <meta name="author" content="Girls Secret Team" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://girls-secret.com/" />
        <meta property="og:title" content="女孩的秘密 - 专业的女性健康管理平台" />
        <meta property="og:description" content="专业的女性健康管理平台，提供月经周期管理、排卵期预测、安全期计算、预产期计算等功能。科学管理女性健康，守护每一个重要时刻。" />
        <meta property="og:image" content="https://girls-secret.com/og-image.jpg" />
        <meta property="og:locale" content="zh_CN" />
        <meta property="og:site_name" content="女孩的秘密" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://girls-secret.com/" />
        <meta name="twitter:title" content="女孩的秘密 - 专业的女性健康管理平台" />
        <meta name="twitter:description" content="专业的女性健康管理平台，提供月经周期管理、排卵期预测、安全期计算、预产期计算等功能。" />
        <meta name="twitter:image" content="https://girls-secret.com/og-image.jpg" />
        
        {/* 移动端优化 */}
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="apple-mobile-web-app-title" content="女孩的秘密" />
        
        {/* 主题色彩 */}
        <meta name="theme-color" content="#FF6B8A" />
        <meta name="msapplication-TileColor" content="#FF6B8A" />
        
        {/* 结构化数据 */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "女孩的秘密",
            "description": "专业的女性健康管理平台，提供月经周期管理、排卵期预测、安全期计算、预产期计算等功能",
            "url": "https://girls-secret.com",
            "applicationCategory": "HealthApplication",
            "operatingSystem": "Web",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "CNY"
            },
            "author": {
              "@type": "Organization",
              "name": "Girls Secret Team"
            },
            "inLanguage": "zh-CN",
            "audience": {
              "@type": "Audience",
              "audienceType": "女性用户"
            }
          })}
        </script>
        
        <title>女孩的秘密 - 专业的女性健康管理平台</title>
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/manifest.json" />
        <link rel="canonical" href="https://girls-secret.com" />
        <link rel="alternate" hreflang="zh-CN" href="https://girls-secret.com" />
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <Meta />
        <Links />
      </head>
      <body className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-indigo-50">
        <Outlet />
        <ScrollRestoration />
        <Scripts />
        <SpeedInsights />
        <Analytics />
        <CustomAnalytics googleAnalyticsId="G-TRTYFW3D5W" />
        <LiveReload />
      </body>
    </html>
  );
}

export function ErrorBoundary({ error }: { error: Error }) {
  return (
    <html lang="zh-CN">
      <head>
        <title>出错了 - 女孩的秘密</title>
        <Meta />
        <Links />
      </head>
      <body className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-indigo-50 flex items-center justify-center">
        <div className="glass-card p-8 text-center max-w-md">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">哎呀，出错了</h1>
          <p className="text-gray-600 mb-6">很抱歉，页面遇到了一些问题。请稍后再试。</p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            重新加载
          </button>
        </div>
        <Scripts />
      </body>
    </html>
  );
}